import { useWindowDimensions } from 'react-native';
import { breakpoints } from '../constants/webStyles';

/**
 * True when the viewport width is below the mobile breakpoint (phones).
 * Single source of truth for responsive branching across web screens.
 * Safe on native (useWindowDimensions is cross-platform), though only the
 * web build branches on it.
 */
export function useIsMobile() {
  const { width } = useWindowDimensions();
  return width < breakpoints.mobile;
}

/** True on very small phones — use only for the tightest layouts. */
export function useIsSmallMobile() {
  const { width } = useWindowDimensions();
  return width < breakpoints.smallMobile;
}
